export default __webpack_public_path__ + "static/media/crossCalender.3cee88b6.svg";